'use client';
import { chakra } from '../system/factory.mjs';

const Strong = chakra("strong", {
  baseStyle: {
    fontWeight: "bold"
  }
});

export { Strong };
